// Canonical localStorage/sessionStorage key names. Previously re-typed as
// raw string literals across AuthContext, axiosInstance, and the *Api.js
// files — a typo in any one of them silently breaks auth with no compile
// error, since they all have to agree on the same literal independently.
const StorageKeys = {
  USER: "user",
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  SIGNUP_EMAIL: "signup_email",
  SEARCH_FILTERS: "searchFilters",
};

export default StorageKeys;
